import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { useToggleGatsbyjsioEnabledMutation } from "../queries.generated"
import {
  SiteDetailsGatsbyjsioEnabledFieldsFragment,
  SiteDetailsGatsbyjsioEnabledFieldsFragmentDoc,
} from "../fragments.generated"

export function useToggleGatsbyjsioEnabled(siteId: string) {
  const [toggleGatsbyjsioEnabledMutation, { loading }] =
    useToggleGatsbyjsioEnabledMutation()
  const [setError, errorAlert] = useTriggerErrorAlert()

  const toggleGatsbyjsio = () => {
    setError(null)
    return toggleGatsbyjsioEnabledMutation({
      variables: {
        siteId,
      },
      update: (proxy, { data }) => {
        if (!data?.toggleGatsbyjsioEnabled?.success) {
          return
        }
        const fragmentInfo = {
          id: `Site:${siteId}`,
          fragment: SiteDetailsGatsbyjsioEnabledFieldsFragmentDoc,
        }

        const site =
          proxy.readFragment<SiteDetailsGatsbyjsioEnabledFieldsFragment>(
            fragmentInfo
          )

        if (!site) {
          return
        }

        site.gatsbyjsioEnabled = !site.gatsbyjsioEnabled

        proxy.writeFragment<SiteDetailsGatsbyjsioEnabledFieldsFragment>({
          ...fragmentInfo,
          data: site,
        })
      },
      optimisticResponse: {
        toggleGatsbyjsioEnabled: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [toggleGatsbyjsio, { loading, errorAlert }] as const
}
